<ng-container *ngIf="useWorkspaces && canSave">
  <button type="button" class="btn btn-primary" (click)="saveChangesToNewWorkspace()" [disabled]="!canSave">
    New Workspace
  </button>
  <button  type="button" class="btn btn-primary helpButton" (click)="actionShowHelpForCreatingRules()" >
    Help for Creating Rules
  </button>
</ng-container>
